import { useEffect, useImperativeHandle, useRef, useState } from 'react';
import { useStateInRef } from '../../../utils/useStateInRef';
import { digitsOf, resolveBoxChange } from './useOTPVerificationField.utils';
export const useOTPVerificationField = (param)=>{
    let { length, hasError, onChange, onInputChange, ref } = param;
    const [values, setValues] = useState(Array(length).fill(''));
    const inputsRef = useRef([]);
    const [error, setError] = useState(hasError);
    useImperativeHandle(ref, ()=>({
            reset: ()=>{
                setError(false);
                emptyBoxesAndFocusFirst();
            }
        }));
    const getEmptyBoxesAndFocusFirst = useStateInRef(emptyBoxesAndFocusFirst);
    useEffect(()=>{
        if (hasError) {
            setError(true);
            getEmptyBoxesAndFocusFirst()();
        } else setError(false);
    }, [
        hasError
    ]);
    useEffect(()=>{
        var _inputsRef_current_;
        (_inputsRef_current_ = inputsRef.current[0]) === null || _inputsRef_current_ === void 0 ? void 0 : _inputsRef_current_.focus();
    }, []);
    function focusInput(index) {
        var _inputsRef_current_index;
        (_inputsRef_current_index = inputsRef.current[index]) === null || _inputsRef_current_index === void 0 ? void 0 : _inputsRef_current_index.focus();
    }
    function emptyBoxesAndFocusFirst() {
        setValues(Array(length).fill(''));
        focusInput(0);
    }
    function reportIfComplete(newValues) {
        const fullCode = newValues.join('');
        if (fullCode.length === length && !newValues.includes('')) {
            onChange === null || onChange === void 0 ? void 0 : onChange(fullCode);
        }
    }
    function fillFromFirstBox(digits) {
        const code = digits.slice(0, length).split('');
        const newValues = [
            ...values
        ];
        code.forEach((char, idx)=>{
            newValues[idx] = char;
        });
        setError(false);
        setValues(newValues);
        reportIfComplete(newValues);
        const nextIndex = code.length >= length ? length - 1 : code.length;
        focusInput(nextIndex);
    }
    const handleChange = (e, index)=>{
        const { value, selectionEnd } = e.target;
        const digits = resolveBoxChange({
            value,
            caret: selectionEnd !== null && selectionEnd !== void 0 ? selectionEnd : value.length,
            previous: values[index]
        }, length);
        if (digits === values[index]) {
            return;
        }
        setError(false);
        onInputChange === null || onInputChange === void 0 ? void 0 : onInputChange();
        if (digits.length > 1) {
            fillFromFirstBox(digits);
            return;
        }
        const newValues = [
            ...values
        ];
        newValues[index] = digits;
        setValues(newValues);
        reportIfComplete(newValues);
        if (digits && index < length - 1) {
            focusInput(index + 1);
        }
    };
    const handleKeyDown = (e, index)=>{
        if (e.key === 'Backspace' && !values[index] && index > 0) {
            const newValues = [
                ...values
            ];
            newValues[index - 1] = '';
            setError(false);
            setValues(newValues);
            focusInput(index - 1);
        }
    };
    const handlePaste = (e)=>{
        e.preventDefault();
        fillFromFirstBox(digitsOf(e.clipboardData.getData('text')));
    };
    return {
        values,
        error,
        inputsRef,
        handleChange,
        handleKeyDown,
        handlePaste
    };
};
